import {createAction} from 'redux-actions';
import * as api from '../services/tickets';
import {
  GET_ORDERS_SUCCESS,
  UPDATE_ORDERS,
  UNUPDATE_ORDER,
  CONCAT_ORDERS
} from '../config/const';

export const getOrders = createAction(GET_ORDERS_SUCCESS, orders => orders);
export const updateOrders = createAction(UPDATE_ORDERS, update => update);
export const unUpdateOrder = createAction(UNUPDATE_ORDER, orderNumber => orderNumber);
export const concatOrders = createAction(CONCAT_ORDERS, orders => orders);

export function startGetOrders() {
  return dispatch => {
    api.getOrders(0).then(
      response => {
        dispatch(getOrders(response.data));
      },
      error => console.log(error)
    );
  };
}

export function startGetMoreOrders(page) {
  return dispatch => {
    api.getOrders(page).then(
      response => {
        const newOrders = response.data.data;
        // concat new orders
        dispatch(concatOrders(newOrders));
      },
      error => console.log(error)
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/order.js